import i18n from '../i18n';
import propaganda from './propaganda';
// 宣传资料
const PROPAGANDA = [
    {
        key: 'FACEBOOK',
        icon: propaganda.FACEBOOK,
        label: 'Facebook'
    },
    {
        key: 'GOOGLE',
        icon: propaganda.GOOGLE,
        label: 'Google'
    },
    {
        key: 'INSTAGRAM',
        icon: propaganda.INSTAGRAM,
        label: 'Instagram'
    },
    {
        key: 'TIK_TOK',
        icon: propaganda.TIK_TOK,
        label: 'Tik Tok'
    },
    {
        key: 'TRIP_ADVISOR',
        icon: propaganda.TRIP_ADVISOR,
        label: 'Trip Advisor'
    },
    {
        key: 'TWITTER',
        icon: propaganda.TWITTER,
        label: 'Twitter'
    },
    {
        key: 'WHATSAPP',
        icon: propaganda.WHATSAPP,
        label:'Whatsapp'
    },
    {
        key: 'OFFICIAL_WEBSITE',
        label: i18n.t('first_screen_setting_page_restaurant_official_website'),
    },
    {
        key: 'RESERVATION',
        label: i18n.t('first_screen_setting_page_reservation_website')
    },
    {
        key: 'TAKEAWAY',
        label: i18n.t('first_screen_setting_page_takeway_website')
    },
]

export default PROPAGANDA